import { EnvironmentProviders, Provider } from '@angular/core';

/** Optional feature kind. */
export enum BarControlsFeatureKind {
    /** Confirmation settings.. */
    ConfirmSettings,
    /** Date-time picker settings. */
    DateTimePickerSettings
}

/** Represents an optional feature for BAR controls.  */
export type BarControlsFeature = {
    /** What kind of feature. */
    kind: BarControlsFeatureKind;
    /** Providers within the feature. */
    providers: (Provider | EnvironmentProviders)[];
};
